export default "__VITE_ASSET__2443f34a__"